{
  "EuroFAANG": {
    "description": "EuroFAANG is a coordinated effort to unravel the connection between the genetic make-up of an animal and the observable physical and physiological traits. The EuroFAANG projects aim to address challenges in farmed animal production.",
    "twitter": {
      "id": "EuroFAANG"
    },
    "url": "https://eurofaang.eu/about",
    "image": {
      "url": "https://github.com/FAANG/comm-data-portal-projects/raw/master/projects/eurofaang/project-logo.png"
    }
  },
  "AQUA-FAANG": {
    "description": "AQUA-FAANG aims to generate genome-wide functional annotation maps for the six commercially most important fish species within European aquaculture and exploit their contribution to variation in traits of commercial\n        relevance, focusing on improved resistance to disease.",
    "twitter": {
      "id": "AQUA_FAANG"
    },
    "url": "https://www.aqua-faang.eu/",
    "image": {
      "url": "https://raw.githubusercontent.com/FAANG/comm-data-portal-projects/master/projects/aquafaang/project-logo.png"
    },
    "parent_project": "EuroFAANG"
  },
  "BovReg": {
    "description": "The BovReg consortium will provide a comprehensive map of functionally active genomic features in cattle and how their (epi)genetic variation in beef and dairy breeds translates into phenotypes.",
    "twitter": {
      "id": "BovReg"
    },
    "image": {
      "url": "https://github.com/FAANG/comm-data-portal-projects/raw/master/projects/bovreg/project-logo.jpg"
    },
    "parent_project": "EuroFAANG"
  },
  "GENE-SWitCH": {
    "description": "GENE-SWitCH aims to deliver new underpinning knowledge on the functional genomes of two main monogastric farm species (pig and chicken) and to enable immediate translation to the pig and poultry sectors.",
    "twitter": {
      "id": "GeneSwitch"
    },
    "url": "https://www.gene-switch.eu/",
    "image": {
      "url": "https://github.com/FAANG/comm-data-portal-projects/raw/master/projects/gene-switch/project-logo.png"
    },
    "parent_project": "EuroFAANG"
  },
  "GEroNIMO": {
    "description": "GEroNIMO will work on chicken and pig, the most used sources of animal protein worldwide, to provide breeders with new knowledge and tools to promote innovative genome and epigenome enabled selection methods for traits related to production (quantity and quality), efficiency, productive longevity, fertility, resilience and welfare.",
    "twitter": {
      "id": "GeronimoH2020"
    },
    "url": "https://www.geronimo-h2020.eu/",
    "image": {
      "url": "https://raw.githubusercontent.com/FAANG/comm-data-portal-projects/master/projects/geronimo/project-logo.png"
    },
    "parent_project": "EuroFAANG"
  },
  "RUMIGEN": {
    "description": "RUMIGEN is a multi-actor project aiming to improve genetic tools in bovine breeds through the addition of new traits such as heat tolerance, and epigenetic information.",
    "twitter": {
      "id": "RUMIGENH2020"
    },
    "url": "https://rumigen.eu/",
    "image": {
      "url": "https://raw.githubusercontent.com/FAANG/comm-data-portal-projects/master/projects/rumigen/project-logo.png"
    },
    "parent_project": "EuroFAANG"
  },
  "Holoruminant": {
    "description": "Holoruminant is a multi-actor project aiming to elucidate the role of ruminant-associated microbiomes and their interplay with the host animal in early life and throughout fundamental life events (e.g. weaning, feed transitions and lactation) that are known to affect health, welfare and environmental efficiency in ruminant production systems.",
    "twitter": {
      "id": "holoruminant"
    },
    "url": "https://holoruminant.eu",
    "image": {
      "url": "https://raw.githubusercontent.com/FAANG/comm-data-portal-projects/master/projects/holoruminant/project-logo.jpeg"
    },
    "parent_project": "EuroFAANG"
  },
  "FAANG": {
    "description": "FAANG is the Functional Annotation of ANimal Genomes project. We are working to understand the genotype to phenotype link in domesticated animals.",
    "twitter": {
      "id": "FAANGOMICS"
    },
    "url": "https://data.faang.org/",
    "image": {
      "url": "https://github.com/FAANG/comm-data-portal-projects/raw/master/projects/faang/project-logo.png"
    }
  },
  "Bovine": {
    "description": "The cattle industry is the largest of the agricultural commodities in the United. Although the sequence of the bovine reference genome has been publicly available since 2009, annotation of functional genome elements is largely incomplete, resulting in limitations for exploiting the genome to phenome relationship. The proposed project will generate high-quality detailed transcript and chromatin status datasets from a comprehensive set of bovine tissues, developmental stages, and cells through a set of rationally selected assays. Experimental data generated by the project will be analyzed using well-established bioinformatics software and pipelines to discover and annotate the functional elements of the bovine genome, including enhancers, promoters, insulators, and small and large RNA transcripts, among others. Datasets and findings will be made publicly available through database and genome information centers. Finally, we will demonstrate the utility of generated information by analyzing datasets for genome wide association studies in relation to the newly added functional annotations. The proposed project is supported by all sectors of the bovine genome community, including multiple research centers across the US and the world, livestock industries, and the international Functional Annotation of ANimal Genomes consortium (FAANG). The project is leading by University of California, Davis and collaborating with Agricultural Research Service USDA, Colorado State University, Iowa State University, Pennsylvania State University, Texas A&M University, University of Idaho, University of Vermont, Virginia Polytechnic Institute and State University, and Washington State University.",
    "twitter": {
      "id": "Bovine"
    },
    "image": {
      "url": "https://github.com/FAANG/comm-data-portal-projects/raw/master/projects/bovine/project-logo.png"
    },
    "parent_project": "FAANG"
  },
  "USPIGFAANG": {
    "description": "The lack of functional annotation of the domestic pig genome prevents full exploitation of single nucleotide variant analysis for genetic improvement through traditional breeding, and limits efficiency of gene editing of specific genome components to understand function and accelerate genetic improvement. We will dramatically increase the depth and breadth of current porcine functional annotation and generate a community resource for scientists in both the public and private sectors. Across all objectives, we will use RNA assays (RNAseq, the 5' end mapping technique RAMPAGE, and PacBio Iso-seq) and epigenetics assays (histone ChIP-seq, ATAC-seq and DNA methylation) to annotate a tremendous breadth of biological states. In Objective 1, we will triple the number of adult tissues currently being annotated. In Objective 2, we will annotate four tissues at important stages of fetal development, and link allele-specific expression with allele-specific functional elements through analyzing divergent-breed reciprocal crosses. In Objective 3, we will annotate circulating white blood cell populations in healthy pigs, as well as macrophage responses to bacterial and viral mimics. We will also profile gene expression of single cells in complex cell populations to maximize annotation of critical immune tissues.  In Objective 4, we will use all these data as well as public FAANG data to generate a first-generation chromatin state segmentation map. All data and associated metadata will be publically available. This is USDA-NIFA-AFRI project 2018-67015-27501 which addresses Program Area Priority A1202, Annotation of Agricultural Animal Genomes.",
    "twitter": {
      "id": ""
    },
    "image": {
      "url": "https://github.com/FAANG/comm-data-portal-projects/raw/master/projects/usfaang/project-logo.png"
    },
    "parent_project": "FAANG"
  }
}
